import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Modal, Form, Button, Typography, Space, Row, Col } from "antd";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { CloseOutlined } from "@ant-design/icons";
import ContactForm from "./ContactForm";
import OpportunityForm from "./OpportunityForm";
import RestrictedComponent from "../../../../components/util/RestrictedComponent";
import ChildrenAnimationWrapper from "../../../../components/animations/ChildrenAnimationWrapper";

const { Title } = Typography;

const ConvertLeadModal = (props) => {
  const { visible, hide, record } = props;
  const [form] = Form.useForm();
  const intl = useIntl();
  const scopePrefix = useSelector((state) => state.user.scopePrefix);
  const dispatch = useDispatch();
  const [formValues, setFormValues] = useState({});
  // const createLoading = useSelector(
  //   (state) => state.pendingActions["tasks/create"]
  // );

  useEffect(() => {
    form.setFieldsValue({
      surename: record.surename,
      first_name: record.first_name,
      opportunity_owner_id: 12,
      contact_owner_id: 12,
    });
  }, [record]);

  const onFinish = async (values) => {
    hide();
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onDecline = () => {
    hide();
  };

  const onValuesChange = (values, form) => {
    setFormValues(values);
  };

  const convertText = intl.formatMessage({
    id: `app.leads.convert_to_opportunity_title`,
  });

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };

  return (
    <Modal
      closable={false}
      maskClosable={false}
      open={visible}
      footer={null}
      onCancel={hide}
      title={null}
      width={"fit-content"}
      styles={{
        body: {
          padding: 0,
        },
      }}
      destroyOnClose={true}
    >
      <div>
        <div className="header" style={{ height: "10px" }}>
          <Button
            style={{ position: "absolute", left: 10, top: 10 }}
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={onDecline}
          />
        </div>
        <Title
          style={{
            fontSize: "30px",
            fontWeight: 500,
            lineHeight: 1.27,
            color: "rgba(0, 0, 0, 0.85)",
            margin: "13px 0 20px 0 ",
            textAlign: "center",
          }}
        >
          {convertText}
        </Title>
        <Form
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={form}
          style={{ width: "900px" }}
          onValuesChange={onValuesChange}
        >
          <ChildrenAnimationWrapper>
            <Space direction="vertical" size="middle" style={{ width: "100%" }}>
              <ContactForm />
              <OpportunityForm />
              <Row style={{ width: "100%" }}>
                <Col
                  span={24}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <RestrictedComponent
                    resource={"leads"}
                    action={"editor"}
                    comp={
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "center",
                          paddingBottom: "30px",
                        }}
                      >
                        <Button onClick={onDecline}>
                          {intl.formatMessage({
                            id: "app.actions.close",
                          })}
                        </Button>
                      </div>
                    }
                  >
                    <Button type="primary" onClick={onFinish}>
                      {intl.formatMessage({
                        id: "app.actions.convert",
                      })}
                    </Button>
                  </RestrictedComponent>
                </Col>
              </Row>
            </Space>
          </ChildrenAnimationWrapper>
        </Form>
      </div>
    </Modal>
  );
};

export default ConvertLeadModal;
